<template>
  <b-modal ref="AnalyseDetailModal" v-model="modalShow" size="lg" id="AnalyseDetailModal" title="">
    <template v-if="(typeof analyse.BTRAGISID != 'undefined')">
      <div class="row">
        <div class="col-6 mb-3" v-if="(typeof betrieb.BTRAGISID != 'undefined')">
          <!--
              [{"BTRAGISID":10009570,"PERDTAID":19736,
              "PERDTABASPERID":101179,"PERDTASYSDOMID":1,
              "PERDTACODRFOID":2,"PERDTACODKNTID":21,"PERDTAKANTONSID":"TG166245",
              "PERDTACODGDEID":4921,"PERDTACODPLZID":5421,"PERDTAANREDE":null,
              "PERDTANAME1":"BG Neuenschwander","PERDTANAME2":null,
              "PERDTAADRESSE1":"Puppikon 18","PERDTAADRESSE2":null,
              "PERDTAZUHANDEN":"Peter und Martin Neuenschwander",
              "PERDTATELEFON1":"071 622 53 09","PERDTATELEFON2":null,"PERDTATELEFON3":null,
              "PERDTAEMAIL":null,"PERDTAURL":null,"PERDTACODBEZID":null,"PERDTABEWWECHSEL":null,"PERDTACHANGEDON":"December, 13 2011 14:51:18","PERDTACHANGEDBY":45,"PERDTACREATEDON":"April, 10 2006 09:02:16","PERDTACREATEDBY":0,"PLZPLZ":9565,"PLZORT":"Rothenhausen"}]
           -->
          <b>{{ analyse.BTRAGISID }}</b><br/>
          {{ betrieb.PERDTAANREDE }} {{ betrieb.PERDTANAME1 }} {{ betrieb.PERDTANAME2 }}<br/>
          {{ betrieb.PERDTAZUHANDEN }}<br/>
          {{ betrieb.PERDTAADRESSE1 }} {{ betrieb.PERDTAADRESSE2 }}<br/>
          {{ betrieb.PLZPLZ }} {{ betrieb.PLZORT }}
        </div>
        <div class="col-6" v-if="(typeof betrieb.BTRAGISID!='undefined')">
          {{ betrieb.PERDTATELEFON1 }}<br/>
          {{ betrieb.PERDTATELEFON2 }}<br/>
          {{ betrieb.PERDTATELEFON3 }}<br/>
          {{ betrieb.PERDTAEMAIL }}<br/>
        </div>
        <analysen-detail-feld :label="$t('Kanton')" :wert="analyse.MPDKANTON" />
        <analysen-detail-feld :label="$t('Probetyp')+'('+analyse.MPDTYPCODELABOR+')'" :wert="$t('CODANATYP_'+analyse.ANATYPID)" />
        <analysen-detail-feld :label="$t('Labor')" :wert="getLaborName(analyse.MPDSYSDOMID)" />
        <analysen-detail-feld :label="$t('Periode')" :wert="analyse.MPDPERIODE" />
        <analysen-detail-feld :label="$t('MBHIdent')" :wert="analyse.MPDMBHID" />
        <analysen-detail-feld :label="$t('AnaIntFld34')" :wert="analyse.MPDBLOCKID" />
        <analysen-detail-feld :label="$t('Flaschennummer')" :wert="analyse.MPDBARCODELABOR" />
        <analysen-detail-feld :label="$t('Probenahme')" :wert="chDate(analyse.MPDDATUM)" />
        <analysen-detail-feld :label="$t('Untersuchung')" :wert="chDate(analyse.MPDUNTERSUCHUNG)" />
        <analysen-detail-feld :label="$t('Storniert')" :wert="analyse.MPDSTORNIERUNG" />
        <analysen-detail-feld  :label="$t('Fehlercode')+'*'" :wert="analyse.MPDMSGCODELABOR" />
        <analysen-detail-feld :label="$t('Tierart')" :wert="$t('CODTierart_'+analyse.MPDCODTIERARTID)" />
        <analysen-detail-feld :label="$t('Produzent')+' '+$t('Nr')" :wert="analyse.MPDPRODUZENT" />
        <analysen-detail-feld :label="$t('Relevant')+' (*)'" :wert="analyse.MPDRELEVANT" />
        <analysen-detail-feld :label="$t('Grenzwert')+' (*)'" :wert="analyse.MPDGRENZWERT" />
        <analysen-detail-feld :label="$t('ID')" :wert="analyse.MPDID" />
        <analysen-detail-feld :label="$t('Referenz')+' '+$t('Labor')" :wert="analyse.MPDREFCODELABOR" />
      </div>
      <div class="row mt-3" v-if="(analyse.ANATYPID !== 2)"><!-- bei Gehalt ausblenden #955 -->
        <div class="col-12">
          <h3>{{$t('Beanstandung')}} {{$t('oeffRecht')}}</h3>
        </div>
        <analysen-detail-feld v-if="(analyse.ANATYPID === 4)" :label="$t('Beanstandungen')+' '+$t('Keimzahl')+' ('+$t('Anz')+')*'" :wert="analyse.MPDBEANKEIME" />
        <analysen-detail-feld v-if="(analyse.ANATYPID === 4)" :label="$t('Beanstandungen')+' '+$t('Zellzahl')+' ('+$t('Anz')+')*'" :wert="analyse.MPDBEANZELLEN" />
        <analysen-detail-feld v-if="(analyse.ANATYPID === 4)" :label="$t('Beanstandungen')+' '+$t('Hemmstoff')+' ('+$t('Anz')+')*'" :wert="analyse.MPDBEANHEMMSTOFF" />
        <analysen-detail-feld :label="$t('Milchliefersperre')" :wert="analyse.MPDMILCHSPERRE" />
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <h3>{{$t('Ergebnisse')}}</h3>
        </div>
        <analysen-detail-feld :label="$t('Keimzahl')+'/ml'" :wert="analyse.MPDKEIME"  v-if="(analyse.ANATYPID !== 2)" /><!-- bei Gehalt ausblenden #955 -->
        <analysen-detail-feld :label="$t('Zellzahl')+'/ml'" :wert="analyse.MPDZELLEN" />
        <analysen-detail-feld :label="$t('Hemmstoff')" :wert="hemmstoff(analyse.MPDHEMMSTOFF)" />
        <template v-if="(analyse.ANATYPID !== 4)"><!-- Beim Monatswert(4) ausblednen -->
          <analysen-detail-feld :label="$t('Gefrierpunkt')+' (°C)'" :wert="analyse.MPDGEFRIERPUNKT" v-if="(analyse.ANATYPID !== 2)" /><!-- bei Gehalt ausblenden #955 -->
          <analysen-detail-feld :label="$t('AdaptionGP')+' (°C)'" :wert="analyse.MPDGEFRIERPUNKT2" v-if="(analyse.ANATYPID !== 2)" /><!-- bei Gehalt ausblenden #955 -->
          <analysen-detail-feld :label="$t('Q75plus')+' (°C)'" :wert="analyse.MPDGEFRIERPUNKT75" v-if="(analyse.ANATYPID !== 2)" /><!-- bei Gehalt ausblenden #955 -->
          <analysen-detail-feld :label="$t('Fett')+' (g/100g)'" :wert="analyse.MPDFETT" />
          <analysen-detail-feld :label="$t('Eiweiss')+' (g/100g)'" :wert="analyse.MPDEIWEISS" />
          <analysen-detail-feld :label="$t('Laktose')+' (g/100g)'" :wert="analyse.MPDLAKTOSE" />
          <analysen-detail-feld :label="$t('Harnstoff')+' (mg/100ml)'" :wert="analyse.MPDHARNSTOFF" />
          <analysen-detail-feld :label="$t('Kasein')+' (g/100g)'" :wert="analyse.MPDKASEIN" />
          <analysen-detail-feld :label="$t('KappaKasein')+' (mg/l)'" :wert="analyse.MPDKAPPAKASEIN" />
          <analysen-detail-feld :label="$t('KappaKaseinBgKg')" :wert="analyse.MPDKAPPAKASEINBGKG" />
          <analysen-detail-feld :label="$t('FreieFettsaeuren')+' (mmol/10 kg)'" :wert="analyse.MPDFETTSAEUREN" />
          <analysen-detail-feld :label="$t('Clostridien')+' ('+$t('Sporen')+'/l)'" :wert="analyse.MPDCLOSTRIDIEN" />
        </template>
        <!--
        "VERNUMMER":null,
        "GEHALTBESTELLT":0,"FFSBESTELLT":0,"BTRDTAGENOSSENSCHAFT":7089,"BTRDTAPRODUZENT":16,"LABNR":null,"ULABNR":7,"MPDID":13804651,
        "MPDBASBTRID":45241,"MPDKANTON":"FR","MPDMBHID":28610,"MPDBLOCKID":null,"MPDGENOSSENSCHAFT":7089,"MPDPRODUZENT":16,"MPDSYSDOMID":38,
        "MPDCODANATYPID":1,"MPDCODTIERARTID":1,"MPDTYPCODELABOR":9,"MPDMSGCODELABOR":0,"MPDREFCODELABOR":15829333,"MPDBARCODELABOR":"90807089000166",
        "MPDPERIODE":201710,"MPDDATUM":"October, 27 2017 00:00:00","MPDUNTERSUCHUNG":"October, 27 2017 13:33:13","MPDSTORNIERUNG":null,
        "MPDSMSVERSAND":null,"MPDEMAILVERSAND":null,"MPDBERICHTVERSAND":null,"MPDBERICHTAUFRUF":null,
        "MPDRELEVANT":1,"MPDBEANKEIME":null,"MPDBEANZELLEN":null,"MPDBEANHEMMSTOFF":null,"MPDMILCHSPERRE":0,
        "MPDGRENZWERT":0,"MPDKEIME":2000,"MPDZELLEN":80000,"MPDHEMMSTOFF":0,"MPDGEFRIERPUNKT":-0.529,"MPDFETT":null,"MPDEIWEISS":null,
        "MPDLAKTOSE":null,"MPDTROCKENMASSE":null,"MPDHARNSTOFF":8,"MPDKASEIN":null,"MPDKAPPAKASEIN":null,"MPDKAPPAKASEINBGKG":null,"MPDZITRONENSAEURE":null,"MPDFETTSAEUREN":null,
        "MPDCHANGEDON":"November, 01 2017 13:26:52","MPDCHANGEDBY":0,"MPDCREATEDON":"October, 30 2017 07:48:48","MPDCREATEDBY":0,
        "ANATYPCODE":"MP","MPBTOTAL":null,"TIERARTID":1,"TIERART":"Kuh","ANATYPID":1,"ANATYPNAME":"Qualität","BTRFRMCODE":"GJB","BTRFRMNAME":"Ganzjahresbetrieb","PROBENSTATUS":2,"_cellVariants":{}}
        -->
        <div class="col-12">
          <a :href="'/resources/1/uploads/' + $t('Erklaerungen') + '_pis.pdf'" target="_blank">*{{ $t('Erklaerungen') }}</a>
        </div>
      </div>
    </template>
    <div slot="modal-footer">
      <b-btn @click.stop="close">{{ $t('close') }}</b-btn>
    </div>
  </b-modal>
</template>

<script>
import {apiURL,axios} from "../main";
import moment from 'moment'

import AnalysenDetailFeld from "../components/AnalysenDetailFeld.vue";
//import analysen from '../store/analysen';

export default {
  name: "AnalysenDetail",
  components: {
    "analysen-detail-feld": AnalysenDetailFeld
  },
  data() {
    return {
      modalShow: false,
      MPDREFCODELABOR: 0, //wird via route/analysen/mpdRefCodeLab gesetzt
      analyse:{},
      betrieb:{}
    };
  },
  computed: {
    labor(){
      return this.$store.state.analysenStore.labor
    }
  },
  methods: {
    hemmstoff(MPDHEMMSTOFF) {
       if (MPDHEMMSTOFF === 0) return 'neg'
       if (MPDHEMMSTOFF === 1) return 'pos'
       return ''
    },
    chDate(value){
      if (!value) return ''
      return moment(value).format('DD.MM.YYYY')
    },
    open(MPDREFCODELABOR) {
      this.MPDREFCODELABOR = MPDREFCODELABOR;
      this.analyse = this.$store.state.analysenStore.analysen.filter(anaX => anaX.MPDREFCODELABOR === this.MPDREFCODELABOR)[0]
      this.loadBetrieb(this.analyse.MPDBASBTRID ,this.analyse.MPDDATUM)
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    hide() {
      this.close();
    },
    getLaborName(labSysDomID){
      return this.labor.filter(labX => labX.labSysDomID === labSysDomID)[0].labName
    },
    async loadBetrieb(btrID, datum) {
      let request = await axios.get(apiURL + 'analysen.cfc?method=getBtrInfo', { params: { 'btrID': btrID, 'datum':  moment(datum).toISOString() } })
      // immer alle
      this.betrieb = request.data[0]
    }
  },
  watch: {
    modalShow: function(newValue) {
      if (!newValue) this.close();
    }
  }
  /*,
  mounted() {
    this.$nextTick(async function() { });
  },
  created() {
    this.$nextTick(async function() {});
  }
  */
};
</script>